<div class="headingContainer text-center" id="divHeadingContainer">
  <h1 id="MainHeading" [ngClass]="{'header-desktop': isDesktopView}" [innerHtml]="heading"></h1>
  <div id="divSubHeading" *ngIf="subHeading" [innerHtml]="subHeading" class="subheading"></div>
</div>
